import {CheckCircleOutlined, NotInterested} from "@mui/icons-material";
import {Box} from "@mui/material";



const ResultIconRenderer = ({data, onOpenAutorizacionLog}) => {
    const dandoClick = async (data) => {
        onOpenAutorizacionLog(data.facturaId);
    }

    return (
        <Box paddingTop={'3px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            {data.envioOperam === true &&
                <CheckCircleOutlined color="success"/>
            }
            {data.envioOperam === false &&
                <NotInterested color="error" style={{cursor: 'pointer'}} onClick={()=> dandoClick(data)} />
            }
        </Box>

    )
}

export default ResultIconRenderer
